import { useParams } from "react-router-dom";
import { ProgramPhases } from "./ProgramPhases";
import { useProgram } from "@platform/hooks/useProgram";

export function ProgramPhasesContainer() {
  const { id: programId } = useParams<{ id: string }>();
  const { phases, currentPhase, isLoading } = useProgram();

  return (
    <ProgramPhases
      currentPhase={currentPhase}
      phases={phases}
      isLoading={isLoading}
      programId={Number(programId)}
    />
  );
}

export default ProgramPhasesContainer;

